export enum FooterSections {
    SERVICES = 'services',
    COMPANY = 'company',
    GET_IN_TOUCH = 'getInTouch'
}